import { AddPhotoIcon } from '@assets/icons/addPhoto';
import type { UploadProps } from 'antd';
import { Upload } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';

const { Dragger } = Upload;

type TInputOfferBulkProps = {
  onChange: (value: string) => void;
  onError?: (message: string) => void;
};

const INVALID_CSV_FILE_ERROR =
  'Formato de arquivo inválido. Envie um arquivo no formato .csv.';

export function InputOfferBulk({
  onChange,
  onError,
}: TInputOfferBulkProps) {
  const props = useMemo<UploadProps>(
    () => ({
      name: 'file',
      multiple: false,
      showUploadList: false,
      customRequest: async options => {
        try {
          const file = options.file as File;

          if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
            const invalidFileError = new Error(INVALID_CSV_FILE_ERROR);
            onError?.(INVALID_CSV_FILE_ERROR);
            options.onError?.(invalidFileError, options.file);
            return;
          }

          const textData = await file.text();
          onError?.('');
          onChange(textData);
          options.onSuccess?.(null, options.file);
        } catch (error: any) {
          options.onError?.(error, options.file);
        }
      },
    }),
    [onChange, onError]
  );

  return (
    <Container>
      <Dragger {...props} style={{ borderRadius: 8 }}>
        <p className='ant-upload-drag-icon'>
          <AddPhotoIcon style={{ fontSize: 48, opacity: 0.5 }} />
        </p>
        <p className='ant-upload-text'>
          <span style={{ color: '#1668DC', fontWeight: 'bold' }}>
            Clique para carregar
          </span>
          <br />
          ou arraste e solte
        </p>
        <p className='ant-upload-hint'>.csv</p>
      </Dragger>
    </Container>
  );
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  min-height: 77vh;
  max-height: 77vh;
  align-items: stretch;

  > label {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-bottom: 8px;
  }

  > span {
    width: 100%;
  }
`;
